import {useLocation, matchPath} from 'react-router-dom';
import {routesConfig, IRouteConfig} from '../config/routes';

function flattenRoutes(routes: IRouteConfig[]): IRouteConfig[] {
    const result: IRouteConfig[] = [];
    routes.forEach(r => {
        result.push(r);
        if (r.children) result.push(...flattenRoutes(r.children));
    });
    return result;
}

const allRoutes = flattenRoutes(routesConfig);

export function usePageTitle(): string {
    const {pathname} = useLocation();

    for (const route of allRoutes) {
        if (route.path && matchPath(route.path, pathname)) {
            return route.label;
        }
    }
    return '';
}